import { IconClinicalTrials } from '@medifind/icons';
import AdWrapper from './adWrapper';

const ClinicalTrialAd = ({ onClick, ...props }) => {
  return (
    <AdWrapper
      {...props}
      icon={<IconClinicalTrials showBackground={false} showBoxShadow={false} width={41} height={50} color={'#645da2'} padding={false} />}
      title={'Need to find the closest trial?'}
      onClick={onClick}
      buttonText={'Sort By Distance'}
    />
  );
};

export { ClinicalTrialAd as default, ClinicalTrialAd };
